import { Message } from './message';

export class InterviewSelectionModel {
    timeSlotId: number;
    comments: string;
    message: Message;
    applicantTimeZone: string;
}
